export const isFilledValue = (value: unknown) =>
	value !== null &&
	value !== undefined &&
	(typeof value !== "string" || value.trim() !== "");
